import type {
  CalculatorData,
  LeasingFormOptions,
  LeasingPeriodGroup,
  RentFormOptions,
  RentPeriodGroup
} from "../types/calculatorData";

export function mapRentPeriodsToFormOptions(rentPeriods: RentPeriodGroup[]): RentFormOptions {
  const result: RentFormOptions = {
    Periods: [],
    Ows: [],
    Mileages: [],
    selectedPeriod: null,
    selectedOws: null,
    selectedMileage: null
  };

  for (const item of rentPeriods) {
    result.Periods.push({ ...item.Period });

    if (item.Period.Status) {
      for (const owGroup of item.Ows) {
        result.Ows.push({ ...owGroup.Ow });

        if (owGroup.Ow.Status) {
          result.Mileages = [...owGroup.Mileages];
          result.selectedPeriod = item.Period.Value;
          result.selectedOws = owGroup.Ow.Value;

          const selectedMileage = owGroup.Mileages.find((mileage) => mileage.Status);
          result.selectedMileage = selectedMileage?.Value ?? null;
        }
      }
    }
  }

  return result;
}

export function mapLeasingPeriodsToFormOptions(leasingPeriods: LeasingPeriodGroup[]): LeasingFormOptions {
  const result: LeasingFormOptions = {
    Periods: [],
    Ows: [],
    Rvs: [],
    selectedPeriod: null,
    selectedOws: null,
    selectedRvs: null
  };

  for (const item of leasingPeriods) {
    result.Periods.push({ ...item.Period });

    if (item.Period.Status) {
      for (const owGroup of item.Ows) {
        result.Ows.push({ ...owGroup.Ow });

        if (owGroup.Ow.Status) {
          result.Rvs = [...owGroup.Rvs];
          result.selectedPeriod = item.Period.Value;
          result.selectedOws = owGroup.Ow.Value;

          const selectedRv = owGroup.Rvs.find((rv) => rv.Status);
          result.selectedRvs = selectedRv?.Value ?? null;
        }
      }
    }
  }

  return result;
}

export function mapCalculatorDataToFormOptions(calculatorData: CalculatorData) {
  return {
    rent: mapRentPeriodsToFormOptions(calculatorData.RentPeriods),
    leasing: mapLeasingPeriodsToFormOptions(calculatorData.LeasingPeriods)
  };
}
